export const DEFAULT_HOME_PAGE = '/jobs';
export const DEFAULT_NEW_HOME_PAGE = '/dashboard?dashboard=job_management';

export const USER_HOME_LOCAL_STORE_KEY_SUFFIX = ':user_home_page';

export const AVAILABLE_LANGUAGE_CODES = [
  'en',
  'fil',
  'es',
  'de',
];